export default "__VITE_ASSET__BvabIjGR__"